import React from 'react'
import { Card, CardHeader, CardText, CardActions } from 'material-ui/Card'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import RaisedButton from 'material-ui/RaisedButton'

const isComplete = reservation => !!reservation.session_sale_id

const CreateReservation = props => (
  <Card>
    <CardHeader title='Create Reservation' />
    <CardText>
      <p>Move this user from the waitlist to the list of reserved users.
      This will create an order with the difference to be paid.
      </p>

      <p>Select the session sale to create a reservation.</p>

      <SelectField
        value={props.reservation.session_sale_id}
        onChange={(e, index, value) => {
          props.onChange({ ...props.reservation, session_sale_id: value })
        }}
        fullWidth
        maxHeight={200}
      >
        {props.sessionSales.map(sessionSale => {
          return (
            <MenuItem
              key={sessionSale.id}
              value={sessionSale.id}
              primaryText={sessionSale.title}
            />
          )
        })}
      </SelectField>
    </CardText>
    <CardActions>
      <RaisedButton
        label='Create Reservation'
        primary
        onClick={props.onSubmit}
        disabled={!isComplete(props.reservation)}
      />
    </CardActions>
  </Card>
)

// @ts-ignore
CreateReservation.propTypes = {
  reservation: React.PropTypes.object.isRequired,
  onChange: React.PropTypes.func.isRequired,
  onSubmit: React.PropTypes.func.isRequired,
  sessionSales: React.PropTypes.arrayOf(React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
    title: React.PropTypes.string.isRequired
  })).isRequired
}

export default CreateReservation
